<template>
  <div>
    <div v-if="is_running && !is_code_verified" class="timer">
      <timer :time="pretty_time" />
    </div>
    <div v-if="is_code_verified" class="success-check">
      <icon type="md-checkmark" />
    </div>
  </div>
</template>

<script>
  import Timer from './timer';

  export default {
    components: { Timer },
    props: {
      is_running: {
        type: Boolean,
        default: false
      },
      is_code_verified: {
        type: Boolean,
        default: false
      },
      pretty_time: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss">
  .ivu-input-with-suffix {
    padding-right: 47px !important;
  }

  .ivu-input-suffix {
    .timer {
      position: absolute;
      top: 7px;
      right: 10px;
    }
    .success-check {
      position: absolute;
      top: 0px;
      right: 10px;
    }

    .ivu-icon-md-checkmark {
      font-size: 20px;
      color: $green;
    }
  }
</style>
